// White Label Branding Configuration
// These values are loaded from environment variables

export const branding = {
  // Application Name
  appName: process.env.REACT_APP_NAME || 'Darb ERP',
  shortName: process.env.REACT_APP_SHORT_NAME || 'DERP',
  
  // Color Theme
  colors: {
    primary: process.env.REACT_APP_PRIMARY_COLOR || '#F56A2C', // rgb(245, 106, 44)
    secondary: process.env.REACT_APP_SECONDARY_COLOR || '#dc004e',
    success: process.env.REACT_APP_SUCCESS_COLOR || '#2e7d32',
  },
  
  // API Configuration
  apiUrl: process.env.REACT_APP_API_URL || 'https://darb.aiastra.io',
};

export default branding;

